module.exports = __webpack_public_path__ + "static/chain_devil-ff0477036651b89a1b165d0370500aa8.jpg";